import config from "../config/config";

export function imageByIndex(id, internal = false) {
  return id ? `${config.api_image}/${id}` : null;
}

export function imageByMMIndex(id, internal = false) {
  return id ? `${config.api_mm_image}/${id}` : null;
}